import { Pipe, PipeTransform } from '@angular/core';
import { Army } from '../models/army';
import { AlphaSortArrayByProperty } from 'starbase-launcher';

@Pipe({
  name: 'armyToRegional'
})
export class ArmyToRegionalPipe implements PipeTransform {

  transform(armies: Army[], armyIdFilter?: number): any[] {
    if (!armies || !armyIdFilter) { return armies; }
    return AlphaSortArrayByProperty(armies.filter(a => a.armyId === armyIdFilter), 'regionalName');
  }

}
